import { csx } from '@vtex/admin-ui'

const styles = {
  nestedMenu: csx({
    '&[aria-current="true"]': {
      color: '$blue40',
    },
  }),
  menuItem: csx({
    '> div': {
      width: '100%',
    },
    svg: {
      minWidth: '1.25rem',
    },
    '&&': {
      '&[aria-current="true"]': {
        color: '$blue40',
        '> *': {
          paddingRight: '0',
        },
      },
    },
  }),
}

export default styles
